import { DndProvider } from 'react-dnd';

import { HTML5Backend } from 'react-dnd-html5-backend';

import AppRouter from './routes';
import { UISettingsProvider } from './context/uiSettingsContext';
import { ThemeProvider } from './context/ThemeContext';
import SystemBrandingSync from './ui-components/SystemBrandingSync';
import { ModalProvider } from './ui-components/modal';
import Toaster from './ui-components/Toaster';

export const App = () => {
  return (
    <DndProvider backend={HTML5Backend}>
      <ThemeProvider>
        <UISettingsProvider>
          <ModalProvider>
            <SystemBrandingSync />
            <AppRouter />
            <Toaster />
          </ModalProvider>
        </UISettingsProvider>
      </ThemeProvider>
    </DndProvider>
  );
};

export default App;
